export default __webpack_public_path__ + "media/images/72-851588212aaa39d4e8de082481e2def9.jpg";